import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { approvalPayload } from 'src/app/models/approvalPayload';
import { commonResponse } from 'src/app/models/commonResponse';
import {
  ProductListResponse,
  pendingProductListResponse
} from 'src/app/models/factoryData';
import { inventoryListResponse } from 'src/app/models/inventoryListResponse';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProductService {
  constructor(private http: HttpClient) {}

  getProductList(query: string): Observable<ProductListResponse> {
    return this.http
      .get<{
        data: ProductListResponse;
      }>(`${environment.base_url}/factory/getProduct?${query}`)
      .pipe(map(res => res.data));
  }

  approveRequest(
    data: approvalPayload,
    id: string
  ): Observable<commonResponse> {
    return this.http.put<commonResponse>(
      `${environment.base_url}/factory/approveInventory/${id}`,
      data
    );
  }

  getPendingList(query: string): Observable<pendingProductListResponse> {
    return this.http
      .get<{
        data: pendingProductListResponse;
      }>(`${environment.base_url}/Factory/getRequestedInventory?${query}`)
      .pipe(map(res => res.data));
  }

  getInventory(query: string): Observable<inventoryListResponse> {
    return this.http
      .get<{
        data: inventoryListResponse;
      }>(`${environment.base_url}/factory/getInventory/${query}`)
      .pipe(map(res => res.data));
  }

  getWalletTransactions(query: string): Observable<any> {
    return this.http
      .get<{
        data: any;
      }>(`${environment.base_url}/factory/factoryDriverTransaction?${query}`)
      .pipe(map(res => res.data));
  }

  getDrivers(query: string): Observable<any> {
    return this.http
      .get<{
        data: any;
      }>(`${environment.operational_url}allDrivers?${query}`)
      .pipe(map(res => res.data));
  }

  submitDriverCash(data: any): Observable<any> {
    return this.http.post<any>(`${environment.base_url}/factory/submitCash`, data);
  }

  printBarcode(variantId: string): Observable<Blob> {
    return this.http.post<Blob>(`${environment.base_url}/factory/print-labels`, { variantId }, {
      responseType: 'blob' as 'json'
    });
  }

  printShelfBarcode(data: { serialNumber: string; variantId: string }): Observable<any> {
    return this.http.post<any>(`${environment.base_url}/factory/print-labels`, data);
  }

  getProductBySerial(serialNumber: string): Observable<any> {
    return this.http
      .get<{ data: any }>(`${environment.operational_url}productBySerial?serialNumber=${serialNumber}`)
      .pipe(map(res => res.data));
  }

  updateInventoryShelfQuantity(
    inventoryId: string, 
    shelvesId: string, 
    payload: { quantity?: number; shelfCode?: string; serialNumber?: string }
  ): Observable<any> {
    return this.http.put<any>(
      `${environment.base_url}/factory/inventory/${inventoryId}/shelves/${shelvesId}`,
      payload
    );
  }
}